<template>
	<div class="container">
		<img src="../assets/image/bj.png" style="width: 100%;">
		<div style="margin-top: -100px; color: white;margin-bottom: 20px;height: 30px;width: 100%;text-align: left;margin-left: 10px;"><span>{{park_name}}</span></div>
		<div class="info container">
		            <div style="background-color: white;margin-top: 15px;border-radius: 2mm;height: 180px;display: flex;flex-direction: column;width: 95%;">
		                <span style="text-align: left;margin: 20px 0 20px 10px;font-weight: 500;font-size: 4mm;">请输入车牌</span>
		                <div style="display: flex;flex-direction: row;justify-content: space-around;">
		                    <div class="no" @click='onFocus(1)'>{{input1}}</div>
		                    <div class="no" @click='onFocus(2)'>{{input2}}</div>
		                    <div class="no" @click='onFocus(3)'>{{input3}}</div>
		                    <div class="no" @click='onFocus(4)'>{{input4}}</div>
		                    <div class="no" @click='onFocus(5)'>{{input5}}</div>
		                    <div class="no" @click='onFocus(6)'>{{input6}}</div>
		                    <div class="no" @click='onFocus(7)'>{{input7}}</div>
		                    <div class="no" :style="styleObject" @click='onFocus(8)'>{{input8}}</div>
		                </div>
						<div style="margin-top: 15px;display: flex;flex-direction: column;justify-content: flex-start;text-align: left;">
							<span style="font-size: 15px;margin-left: 10px;">我的车辆</span>
							<div class="carno" style="display: flex;flex-direction: row;margin-top: 20px;width: 100%;justify-content: end;">
							    <div v-for="item in stroryNos">
							        <img src="../assets/image/sc.png" class="x" @click="RemoveStory(item)"/>
							        <span style="padding-right: 15px;font-size: 14px;" @click="SelectNo(item)">{{item}}</span>
							    </div>
							</div>
						</div>
		            </div>
					

					<van-popup v-model="showPlate" position="bottom" :style="{ height: '30%' }" >
						<div class="plate" style="margin-top: 20px;margin-left: 1%;">
		                    <span class="n" v-for='item in platenos1' @click='plateClick(item)'>
		                        {{item}}
		                    </span>
		                </div>
		                <div class="plate" style="margin-top: 10px;margin-left: 1%;">
		                    <span class="n" v-for='item in platenos2' @click='plateClick(item)'>
		                        {{item}}
		                    </span>
		                </div>
		                <div class="plate" style="margin-top: 10px;margin-left: 1%;"> 
		                    <span class="n" v-for='item in platenos3' @click='plateClick(item)'>
		                        {{item}}
		                    </span>
		                </div>
		                <div class="plate" style="margin-top: 10px;margin-left: 1%;">
		                    <span class="n" v-for='item in platenos4' @click='plateClick(item)'>
		                        {{item}}
		                    </span>
		                   
		                </div>
					</van-popup>


					<van-popup v-model="showNo" position="bottom" :style="{ height: '30%' }" >
						<div class="plate" style="margin-top: 20px;margin-left: 1%;">
		                    <span class="n" v-for='item in platenos5' @click='noClick(item)'>
		                        {{item}}
		                    </span>
		                </div>
		                <div class="plate" style="margin-top: 10px;margin-left: 1%;">
		                    <span class="n"  v-for='item in platenos6' @click='noClick(item)'>
		                        {{item}}
		                    </span>
		                </div>
		                <div class="plate" style="margin-top:10px;margin-left: 1%;">
		                    <span class="n"  v-for='item in platenos7' @click='noClick(item)'>
		                        {{item}}
		                    </span>
		                </div>
						<div class="plate" style="margin-top:10px;margin-left: 1%;">
		                    <span class="n"  v-for='item in platenos8' @click='noClick(item)'>
		                        {{item}}
		                    </span>
		                </div>
		                <div class="plate" style="margin-top: 10px;margin-left: 1%;">
		                    <span class="n"  v-for='item in platenos9' @click='noClick(item)'>
		                        {{item}}
		                    </span>
		                    <div style="width: 40px;height: 40px;" @click='Del'>
		                        <img src="../assets/image/del.png" style="width: 100%;height: 100%;">
		                    </div>
		                </div>
					</van-popup>


					
					
					<el-button type="primary" style="width: 100%;height: 35px;margin-top: 15px;font-size: 18px;" @click='btnQuery' :loading="queryLoading">查询缴费</el-button>
		</div>
	</div>
</template>

<script>
	import {post} from '../util/util'
	import { Popup } from 'vant';
	import 'vant/lib/popup/style';
	import { Dialog } from 'vant';
	import 'vant/lib/dialog/style';

	export default {
		data() {
			return {
				park_name:'测试车场',

				stroryNos:[],

				input1:'',
				input2:'',
				input3:'',
				input4:'',
				input5:'',
				input6:'',
				input7:'',
				input8:'新能源',
				
				platenos1:['京','沪','津','浙','粤','苏','鲁','晋','冀','豫'],
				platenos2:['渝','辽','黑','吉','皖','鄂','湘','赣','闽'],
				platenos3:['川','陕','甘','宁','蒙','桂','云','贵'],
				platenos4:['琼','青','新','藏','使','无','电'],
				
				platenos5:['1','2','3','4','5','6','7','8','9','0'],
				platenos6:['Q','W','E','R','T','Y','U','O','P'],
				platenos7:['A','S','D','F','G','H','J','K','L'],
				platenos8:['Z','X','C','V','B','N','M','学'],
				platenos9:['港','澳','学','领','挂'],
				
				showPlate:false,
				showNo:false,
				noIndex:0,

				queryLoading:false,

				authForm:null,
			}
		},
		components: {
            [Popup.name]: Popup,
			[Dialog.name]: Dialog,
        },
		computed: {
			styleObject() {
				return {
					fontSize: this.input8==='新能源'?'11px':'15px',
					backgroundColor:this.input8==='新能源'?'green':'white',
					color:this.input8==='新能源'?'white':'black'
				}
			}
		},
		created() {
			let form= window.sessionStorage.getItem("ca_pay_authForm")
			if(form){
				this.authForm = JSON.parse(form)
			}
		},
		mounted(){
			this.getLocationPlate()
		},
		methods: {
			getLocationPlate(){
				this.stroryNos=[]
				let nos= window.localStorage.getItem('ca_prepay_plateno')
				if(nos)
					this.stroryNos= nos.split(",")
			},

			onFocus(index){
			    this.showPlate=false
			    this.showNo=false
				this.noIndex=0
			    if(index===1){
			        this.showPlate=true
			    }
			    if(index>1){
			        this.showNo=true
					this.noIndex=index
			    }  
			},
			plateClick(item){
				this.input1=item
				this.showPlate=false
				this.showNo=true
				this.noIndex=2
			},
			noClick(item){
				switch(this.noIndex){
					case 2:	this.input2=item;break
					case 3:	this.input3=item;break
					case 4:	this.input4=item;break
					case 5:	this.input5=item;break
					case 6:	this.input6=item;break
					case 7:	this.input7=item;break
					case 8:	this.input8=item;break
				}
				this.noIndex++
			},
			Del(){
				if(this.input8&&this.input8!=='新能源'){
					this.input8='新能源'
					this.noIndex=8
				}
				else if(this.input7){
					this.input7=''
					this.noIndex=7
				}
				else if(this.input6){
					this.input6=''
					this.noIndex=6
				}
				else if(this.input5){
					this.input5=''
					this.noIndex=5
				}
				else if(this.input4){
					this.input4=''
					this.noIndex=4
				}
				else if(this.input3){
					this.input3=''
					this.noIndex=3
				}
				else if(this.input2){
					this.input2=''
					this.noIndex=2
				}
				else if(this.input1){
					this.input1=''
					this.noIndex=1
				}
			},
			btnQuery(){
				let no=this.input1+this.input2+this.input3+this.input4+this.input5+this.input6+this.input7+(this.input8==='新能源'?'':this.input8)
				if(!no||no.length<7){
					Dialog({ message: '请输入正确的车牌号' })
					return
				}
				
				let nos= window.localStorage.getItem('ca_prepay_plateno')

				if(nos){
					let platenos= nos.split(",")
					let arr= platenos.filter(a=>a===no)
				
					if(arr.length===0){
						platenos.push(no)
						nos=platenos.join(',')
						window.localStorage.setItem('ca_prepay_plateno',nos)
					}
				}
				else{
					nos=no
					window.localStorage.setItem('ca_prepay_plateno',nos)
				}
				this.getLocationPlate()

				this.authForm.carNumber=no
				
				this.queryLoading=true
				post('pp/queryprice',this.authForm).then(res=>{
					this.$router.push({name:'queryresult',params:{info:JSON.stringify(res)}})
					this.queryLoading=false
				})
			},
			RemoveStory(item){
				let nos= window.localStorage.getItem('ca_prepay_plateno')
				let items= nos.split(",")
				let arr= items.filter(a=>a!==item)
				nos=arr.join(',')
				window.localStorage.setItem('ca_prepay_plateno',nos)
				this.getLocationPlate()

				let plate=this.input1+this.input2+this.input3+this.input4+this.input5+this.input6+this.input7+this.input8
				if(item===plate){
					for(let i=0;i<8;i++){
						this.Del()
					}
					this.noIndex=0	
				}

			},
			SelectNo(item){
				this.input1=item.substring(0,1)
				this.input2=item.substring(1,2)
				this.input3=item.substring(2,3)
				this.input4=item.substring(3,4)
				this.input5=item.substring(4,5)
				this.input6=item.substring(5,6)
				this.input7=item.substring(6,7)
				let char=item.substring(7,8)
				if(char)
					this.input8=item.substring(7,8)
				else
					this.input8='新能源'
			}
		}
	}
</script>

<style scoped>
.container{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.info{
    width: 100%;
    height: 90vh;
    background-color: #F6F6F6;
    margin-top: -1rem;
    border-radius: 5mm 5mm 0 0;

}
.no{
    border: 1px solid #007736;
	border-radius: 6px;
    width: 30px;
    height: 30px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
	font-weight: 600;
}


.plate{
    display: flex;
    flex-direction: row;
    justify-content:space-around;
    align-items: center;
	width: 98%;
}

.plate span{
    background-color: white;
    width: 40px;
    height: 30px;
    margin-right: 3px;
	border: #c3c3c3 1px solid;
	border-radius: 5px;
    font-weight: 600;
  
	text-align: center;
}

.n{
	display: flex;
    flex-direction: row;
    justify-content:center;
    align-items: center;
}


.x{
    position:relative;
    top: -10px;
    right: 5px;
    width: 15px;
    height: 15px;
}

</style>
